import { Language } from "#/language"
type Items = {
  days: (count: number) => string
  hours: (count: number) => string
  months: (count: number) => string
  points: (count: number) => string
  points2: (count: number) => string
  years: (count: number) => string
}
type Translations = Record<Language, Items>
export const translations: Translations = {
  et: {
    days(count: number) {
      return count === 1 ? "p\u00E4ev" : "p\u00E4eva"
    },
    hours(count: number) {
      return count === 1 ? "tund" : "tundi"
    },
    months(count: number) {
      return count === 1 ? "kuu" : "kuud"
    },
    points(count: number) {
      return count === 1 ? "punkt" : "punkti"
    },
    points2(count: number) {
      return count === 1 ? "punkt" : "punkti"
    },
    years(count: number) {
      return count === 1 ? "aasta" : "aastat"
    },
  },
  en: {
    days(count: number) {
      return count === 1 ? "day" : "days"
    },
    hours(count: number) {
      return count === 1 ? "hour" : "hours"
    },
    months(count: number) {
      return count === 1 ? "month" : "months"
    },
    points(count: number) {
      return count === 1 ? "point" : "points"
    },
    points2(count: number) {
      return count === 1 ? "point" : "points"
    },
    years(count: number) {
      return count === 1 ? "year" : "years"
    },
  },
}
